<template>
  <div>
    <div class="filter-form">
      <a-form-model layout="inline" :form="filterForm" :model="filterForm">
        <a-form-model-item label="版本">
          <a-select v-model="filterForm.version" style="width: 120px" allow-clear @change="onSearch">
            <a-select-option v-for="item in versions" :key="item" :value="item">{{ item }}</a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="类型">
          <a-select v-model="filterForm.category" style="width: 120px" allow-clear @change="onSearch">
            <a-select-option value="debug">debug</a-select-option>
            <a-select-option value="release">release</a-select-option>
          </a-select>
        </a-form-model-item>
      </a-form-model>
    </div>
    <a-table :pagination="pagination" :columns="columns" :loading="loading" size="middle" :data-source="versionData" row-key="release_id" class="version-table" @change="handleTableChange">
      <span slot="showQrCode" slot-scope="text, record">
        <a-icon type="qrcode" class="qr-code-button" @click="onShowQrCode(record)" />
      </span>
      <span slot="releaseId" slot-scope="text, record">
        <a class="a-download" :href="record.path" target="_blank">{{ record.release_id }}</a>
      </span>
      <span slot="tags" slot-scope="text, record">
        <a-tag v-for="(tag, index) in record.tags" :key="index" color="cyan">{{ versionTags[tag].label }}</a-tag>
      </span>
      <span slot="action" slot-scope="text, record">
        <a-dropdown placement="bottomCenter">
          <a class="ant-dropdown-link"> 更多 <a-icon type="down" /> </a>
          <a-menu slot="overlay">
            <a-menu-item>
              <a class="ant-dropdown-link" @click="onEdit(record)">编辑标签</a>
            </a-menu-item>
            <a-menu-item>
              <a class="ant-dropdown-link" @click="onPush(record)">推送消息</a>
            </a-menu-item>
            <a-menu-item>
              <a class="ant-dropdown-link" @click="onDownloadFile(record)">下载文件</a>
            </a-menu-item>
            <a-menu-item v-if="record.dsym_url">
              <a class="ant-dropdown-link" @click="onDownloadDsym(record)">下载dSYM</a>
            </a-menu-item>
          </a-menu>
        </a-dropdown>
      </span>
      <span slot="expandedRowRender" slot-scope="record" style="white-space: pre-wrap; margin: 0">
        <h4>更新日志:</h4>
        <span>{{ record.changelog }}</span>
      </span>
    </a-table>
    <version-modal :is-show="editVisible" :version-id="versionId" :tags="tags" @close="close" />
    <version-push-modal :is-show="pushVisible" :version-id="versionId" :changelog="changelog" @close="close" />
    <qr-code-modal :is-show="modalVisible" :content="content" @close="close" />
  </div>
</template>
<script>
import { applicationVersionList } from '@/api/tools/application';
import QrCodeModal from '@/pages/tools/application/components/QrCodeModal';
import VersionModal from '@/pages/tools/application/components/VersionModal';
import VersionPushModal from '@/pages/tools/application/components/VersionPushModal';

const columns = [
  {
    title: 'ID',
    dataIndex: 'version_id',
    key: 'version_id',
    align: 'center',
    width: '5%'
  },
  {
    title: '版本',
    dataIndex: 'version',
    key: 'version',
    align: 'center',
    width: '12%'
  },
  {
    title: '构建版本',
    dataIndex: 'build_version',
    key: 'build_version',
    align: 'center',
    width: '12%'
  },
  {
    title: '分类',
    dataIndex: 'category',
    key: 'category',
    align: 'center',
    width: '12%'
  },
  {
    title: '标签',
    key: 'tags',
    scopedSlots: { customRender: 'tags' }
  },
  {
    title: '更新时间',
    key: 'created_time',
    align: 'center',
    width: '18%',
    dataIndex: 'created_time'
  },
  {
    title: '二维码',
    key: 'url',
    dataIndex: 'url',
    align: 'center',
    width: '10%',
    scopedSlots: { customRender: 'showQrCode' }
  },
  {
    title: '操作',
    align: 'center',
    width: '8%',
    scopedSlots: { customRender: 'action' }
  }
];
export default {
  components: { QrCodeModal, VersionModal, VersionPushModal },
  props: {
    appKey: {
      type: [String, Number],
      default: null
    },
    versions: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  data() {
    return {
      columns,
      loading: false,
      editVisible: false,
      pushVisible: false,
      modalVisible: false,
      versionTags: {
        1: { label: 'QA', value: 1 },
        2: { label: 'Demo', value: 2 },
        3: { label: 'Prod', value: 3 }
      },
      tags: [],
      content: {},
      changelog: null,
      versionData: [],
      filterForm: {
        app_key: null,
        version: null,
        category: null,
        page_size: 10,
        page_number: 1
      },
      pagination: {
        size: 'large',
        total: 0,
        current: 1,
        pageSize: 10, // 每页中显示10条数据
        showSizeChanger: true,
        pageSizeOptions: ['10', '20', '50', '100'], // 每页中显示的数据
        showTotal: total => `共 ${total} 条` // 分页中显示总的数据
      },
      versionId: null
    };
  },
  watch: {
    appKey() {
      this.filterForm.app_key = this.appKey;
      this.pagination.current = 1;
      this.getApplicationVersionList();
    }
  },
  created() {
    this.filterForm.app_key = this.appKey;
    this.getApplicationVersionList();
  },
  methods: {
    getApplicationVersionList() {
      if (this.appKey) {
        this.loading = true;
        applicationVersionList({ ...this.filterForm, page_size: this.pagination.pageSize, page_number: this.pagination.current })
          .then(res => {
            this.loading = false;
            this.versionData = res.data.items;
            this.pagination.total = res.data.total;
          })
          .catch(() => {
            this.loading = false;
          });
      }
    },

    onSearch() {
      this.pagination.current = 1;
      this.getApplicationVersionList();
    },

    handleTableChange(pagination) {
      pagination.current = pagination.pageSize !== this.pagination.pageSize ? 1 : pagination.current;
      this.pagination = pagination;
      this.getApplicationVersionList();
    },

    onEdit(record) {
      this.editVisible = true;
      this.tags = record.tags;
      this.versionId = record.version_id;
    },

    onDownloadDsym(record) {
      window.open(record.dsym_url);
    },

    onDownloadFile(record) {
      window.open(record.file_url);
    },

    // 点击查看二维码
    onShowQrCode(record) {
      this.content = record;
      this.modalVisible = true;
    },

    onPush(record) {
      this.pushVisible = true;
      this.changelog = record.changelog;
      this.versionId = record.version_id;
    },

    // 关闭弹窗
    close(type = 'close') {
      this.modalVisible = false;
      this.editVisible = false;
      this.pushVisible = false;
      this.tags = [];
      this.changelog = null;
      this.versionId = null;
      if (type === 'close') {
        this.getApplicationVersionList();
      }
    }
  }
};
</script>
<style lang="less" scoped>
.qr-code-button {
  font-size: 24px;
}
.filter-form {
  margin-bottom: 12px;
}
</style>
